import Evented from '../Evented';
import RequestLoop from './RequestLoop';
export default class LongPollTransport extends Evented {
    constructor(channelPath, options) {
        super();
        this.lastMessageSequence = 0;
        this.uri = `${options.ssl ? 'https' : 'http'}:${options.host}${channelPath}`;
        this.options = options;
    }
    get didSuccessfullyConnect() { return !!this.loop && this.loop.didSuccessfullyConnect; }
    start() {
        this.loop = new RequestLoop(this.uri, this.lastMessageSequence, this.options);
        this.listenTo(this.loop, 'message', (message, frame) => this.emit('message', message, frame));
        this.listenTo(this.loop, 'connected', (type) => this.emit('connected', type));
        this.listenTo(this.loop, 'up', () => this.emit('up'));
        this.listenTo(this.loop, 'down', () => this.emit('down'));
        this.listenTo(this.loop, 'heartbeat', () => this.emit('heartbeat'));
        this.listenTo(this.loop, 'reconnecting', () => this.emit('reconnecting'));
        this.listenTo(this.loop, 'failed', (type, frame) => this.emit('failed', type, frame));
    }
    stop() {
        if (this.loop) {
            this.lastMessageSequence = this.loop.lastMessageSequence;
            this.loop.stop();
            this.stopListening(this.loop);
            delete this.loop;
        }
    }
}
//# sourceMappingURL=LongPollTransport.js.map